import { render, staticRenderFns } from "./tagsExternalReview.vue?vue&type=template&id=a0b55bd4&scoped=true&lang=pug"
import script from "./tagsExternalReview.vue?vue&type=script&lang=js"
export * from "./tagsExternalReview.vue?vue&type=script&lang=js"
import style0 from "./tagsExternalReview.vue?vue&type=style&index=0&id=a0b55bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b55bd4",
  null
  
)

export default component.exports